import Route from '@ember/routing/route';

export default class ParentViewRoute extends Route {}
